<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_re8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <div
          style="width:100%;display:flex;align-items:center;justify-content:space-between;"
        >
          <div>
            <el-button
              v-if="getLimit('financeReview_search_button')"
              @click="funcFilter"
            >
              查询
            </el-button>
            <el-button
              v-if="getLimit('financeReview_export_button')"
              @click="funcExport"
            >
              导出
            </el-button>
          </div>
          <div style="margin-right:30px;">
            <span style="font-weight:bold;">剩余可开票额度:&ensp;</span>
            <span
              v-show="!isRefreshing"
              style="margin-right:15px;"
              v-for="item in branchListAll"
              >{{ item.groupName }}:&ensp;{{
                formatNum(item.surplusCreditLine) || "--"
              }}</span
            >
            <span v-show="isRefreshing">--</span>
            <!-- {{ isRefreshing ? "--" : formatNum }}元 -->
            <i
              @click="getCreditLineAllBranchApi"
              style="font-size:18px;color:#409eff;cursor:pointer;"
              :class="['el-icon-refresh', { spin: isRefreshing }]"
            ></i>
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      show-footer
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="groupCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.groupCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceTitle"
          title="发票抬头"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceTitle"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxRegistrationNumber"
          title="税务登记证号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.taxRegistrationNumber"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- return item ? item.label : ''; -->
      <vxe-table-column>
        <vxe-table-column
          field="staffType"
          title="托运人类型"
          min-width="160"
          :formatter="
            ({ cellValue }) => {
              const item = shipmentOptions.find(
                item => item.value === cellValue
              );
              return '企业托运人';
            }
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.staffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receiverName"
          title="申请人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiverName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="receiverPhone"
          title="托运人电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.receiverPhone"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="invoiceAmount"
          title="开票总金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.invoiceAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.invoiceAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="申请时间"
          width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="authStatus"
          title="审核状态"
          :formatter="formatterAuthStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.authStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in authStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" fixed="right" min-width="100">
        <template v-slot="{ row }">
          <el-tooltip
            v-if="getLimit('financeReview_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(row.code, row)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="
              getLimit('financeReview_audit_button') &&
                row.authStatus == '0' &&
                (isAdmin || row.applyStatus == '0')
            "
            class="item"
            effect="dark"
            content="审核"
            placement="top"
          >
            <vxe-button type="text" @click="funcAudit(row.code, row.step, row)">
              <i class="el-icon-s-check" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-else-if="
              (getLimit('financeReview_auditInfo_button') &&
                (row.authStatus != '0' || row.groupCode != branchCode)) ||
                (isAdmin || row.applyStatus != '0')
            "
            class="item"
            effect="dark"
            content="审核信息"
            placement="top"
          >
            <vxe-button type="text" @click="funcAudit(row.code, -1)">
              <i class="el-icon-tickets" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal v-model="modelAuditFlag" title="审核" width="980" resize>
      <compAudit
        v-if="modelAuditFlag"
        ref="auditRef"
        :process-type="processType"
        :process-api="processApi"
        :sigleInfo="sigleInfo"
        @fatherAuditMethod="fatherAudit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal v-model="modelDetailFlag" title="详情" width="980" resize>
      <compDetail
        v-if="modelDetailFlag"
        :sigleInfo="sigleInfo"
        ref="detailRef"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getCreditLineAllBranch } from "@/api/user";
import compDetail from "@/views/tms/invoice/drawInvoice/components/invoiceDetail.vue";
import compAudit from "@/views/tms/review/audit.vue";
import request from "@/utils/request";
export default {
  name: "Parent",
  components: {
    compDetail,
    compAudit
  },
  data() {
    return {
      branchListAll: [],
      exportObj: {
        exportUrl: "/ntocc-basic-api/invoice/exportInvoiceAuditList", //导出接口
        name: "开票审核"
      },
      processType: "5",
      processApi: "ntocc-basic-api/invoice",
      loading: false,
      tableData: [],
      modelAuditFlag: false,
      modelDetailFlag: false,
      listQuery: {
        gmtCreatedRange: "",
        freightAmount: "",
        invoiceAmount: "",
        invoiceTitle: "",
        taxRegistrationNumber: "",
        invoiceStatus: 0,
        invoiceIssuedTime: "",
        invoiceConfirmTime: "",
        receiverName: "",
        receiverPhone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      sumObject: {
        invoiceAmount: 0
      },
      authStatusList: [
        { label: "审核中", value: "0" },
        { label: "已通过", value: "1" },
        { label: "已驳回", value: "2" }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: "SHIPMENT" },
        { label: "企业托运人", value: "SHIPMENT_COMPANY" }
      ],
      //机构信息
      branchList: this.$store.state.components.branchList,
      //当前登录机构code
      branchCode: this.$store.state.user.party.branchCode,
      sigleInfo: {},
      totalCreditLine: null,
      isRefreshing: false
    };
  },
  computed: {},
  created() {
    this.findList();
    this.getCreditLine();
    const partyType = this.$store.getters.party.partyType;
    this.isAdmin = partyType == "PLAT_ADMIN";
    this.getCreditLineAllBranchApi();
  },
  methods: {
    formatNum(totalCreditLine) {
      let num;
      if (totalCreditLine === null) {
        num = "--";
      } else {
        num = totalCreditLine.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return num;
    },
    getCreditLine() {
      this.isRefreshing = true;
      request({
        url: `/ntocc-basic-api/invoice/getCreditLine`,
        method: "get",
        params: {}
      })
        .then(response => {
          console.log("======信用额度=======", response);
          if (response.status === 0) {
            setTimeout(() => {
              this.totalCreditLine = +response.data.surplusCreditLine;
              this.isRefreshing = false;
            }, 1000);
          } else {
            this.isRefreshing = false;
            this.$message.error(response.msg);
          }
        })
        .catch(call => {
          this.isRefreshing = false;
        });
    },
    getCreditLineAllBranchApi() {
      this.isRefreshing = true;
      getCreditLineAllBranch()
        .then(res => {
          console.log("======全部的信用额度=======", res);
          if (res.status === 0) {
            setTimeout(() => {
              this.branchListAll = res.data.data;
              this.isRefreshing = false;
            }, 1000);
          } else {
            this.isRefreshing = false;
            this.$message.error(response.msg);
          }
        })
        .catch(call => {
          this.isRefreshing = false;
        });
    },
    // 翻译状态
    formatterAuthStatus({ cellValue }) {
      const item = this.authStatusList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },

    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: `/ntocc-basic-api/invoice/page4Review`,
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 审核方法
    funcAudit(code, step, row) {
      console.log("======审核方法=======", row);
      // if (+row.invoiceAmount > this.totalCreditLine) {
      //   this.$message({
      //     type: "warning",
      //     message: "可开票金额不足，请申请额度后重试"
      //   });
      //   return;
      // }
      this.sigleInfo = row;
      this.modelAuditFlag = true;
      this.$nextTick(() => {
        this.$refs.auditRef.getInfo(code, step);
      });
    },
    // 详情方法
    funcDetail(code, row) {
      this.sigleInfo = row;
      this.modelDetailFlag = true;
      this.$nextTick(() => {
        this.$refs.detailRef.getInfo(code);
      });
    },
    // 编辑组件的父方法
    fatherAudit() {
      this.modelAuditFlag = false;
      this.findList();
      this.getCreditLine();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "audit":
          this.modelAuditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "invoiceAmount") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    }
  }
};
</script>
<style lang="scss" scoped>
.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
